import { FormInstanceForResolver } from "db/definitions";
import { batchAddFormInstances } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { recordSentry } from "utils/recordSentry";

async function batchCreateFormInstances(formInstances: FormInstanceForResolver[]): Promise<boolean> {
	if (formInstances.length > 0) {
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchAddFormInstances,
				variables: { formInstances },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			recordSentry({ error });
		}
		return false;
	}
	return true;
}

export default batchCreateFormInstances;
